import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationComponent } from './authentication.component';
import { AuthenticationService } from './services/authentication.service';

export const AUTH_ROUTES: Routes = [
  { path: 'authenticate', component: AuthenticationComponent }
];



// WEBPACK FOOTER //
// ./~/@c4/auth/src/app/auth-routing.module.ts